import LayoutContent from "../components/LayoutContent";
import LoginBox from "../components/LoginBox";
import { useTranslation } from "react-i18next";

const CustomLogin = () => {
  const { t } = useTranslation();

  // @ts-ignore
  const logo_header = window.welcome.logo_welcome;

  return (
    <LayoutContent>
      <div className="CustomLogin">
        <div className="CustomLogin__logo">
          {logo_header && <img className="CustomLogin__logo--img" alt="logo" src={logo_header} />}
        </div>
        <div className="CustomLogin__container">
          <div className="CustomLogin__content">
            <div className="CustomLogin__box">
              <header className="CustomLogin__header">
                <h1 className="CustomLogin__title">
                  <span className="CustomLogin__title--Label">{t("Login")}</span>
                  {/* @ts-ignore */}
                  {window.login_page.title}
                </h1>
              </header>
              <LoginBox 
                wheel={{
                  // @ts-ignore
                  data: window.categories,
                }}
                // @ts-ignore
                categoryList={window.categories}
                members={[]}
              />
            </div>
          </div>
        </div>
      </div>
    </LayoutContent>
  );
};

export default CustomLogin;
